// extracted by mini-css-extract-plugin
module.exports = {"unit-indicator":"withUnitDeletion_unit-indicator__YNQY_"};